/* eslint-disable import/prefer-default-export */

export const getIsTouchscreen = () => (
  'ontouchstart' in document.documentElement
);
